import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type AISeoGenerateRequest as SchemaAISeoGenerateRequest } from '../schemas/AISeoGenerateRequest';
import { type GenerateAISeoShortResponse as SchemaGenerateAISeoShortResponse } from '../schemas/GenerateAISeoShortResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Pages
 */
export const GenerateAISeoForCollectionPageContentType = 'application/json' as const;
export type GenerateAISeoForCollectionPageRequest = SchemaAISeoGenerateRequest;
export type GenerateAISeoForCollectionPageResponses = LinkCommonErrorResponses & {
    /**
     * @description Успешная генерация сео текстов
     */
    '200': {
        'application/json': SchemaGenerateAISeoShortResponse;
    };
};
export type GenerateAISeoForCollectionPageResponseSuccess =
    GenerateAISeoForCollectionPageResponses['200']['application/json'];
export type GenerateAISeoForCollectionPageSearchParams = undefined;
export type GenerateAISeoForCollectionPagePathParameters = undefined;
export const GenerateAISeoForCollectionPageUrl = '/pages/collections/seo/ai/generate' as const;
export const GenerateAISeoForCollectionPageMethod = 'POST' as const;
export const getGenerateAISeoForCollectionPageUrl = (_params?: GenerateAISeoForCollectionPagePathParameters) =>
    GenerateAISeoForCollectionPageUrl;
